import { PageOptions } from "../../util/page";

export class ParametersOrderPayPending{
    companyId: number = null;
    dateStart: string = null;
    dateFinish: string = null;
    pageOptions: PageOptions; 
}